"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/* ++++++++++ --------------- ITEM SELECTOR LIST : DEFINITION --------------- ++++++++++ */

var _default2 = {
  name: 'ItemSelectorList',
  group: 'Lists',
  props: {
    items: {
      type: 'array',
      default: [{
        text: 'united states',
        selected: true
      }, {
        text: 'united kingdom',
        selected: false
      }, {
        text: 'canada',
        selected: true
      }, {
        text: 'ukraine',
        selected: false
      }, {
        text: 'india',
        selected: false
      }]
    },
    allItemsListIcon: {
      type: 'string',
      default: 'list'
    },
    allItemsListTitle: {
      type: 'string',
      default: 'All Items List'
    },
    selectedItemsListIcon: {
      type: 'string',
      default: 'check'
    },
    selectedItemsListTitle: {
      type: 'string',
      default: 'Selected Items List'
    },
    marginRight: {
      type: 'string',
      default: '8%'
    },
    hasSearchBar: {
      type: 'boolean',
      default: true,
      options: [true, false]
    },
    searchPlaceholderText: {
      type: 'string',
      default: 'Search ...'
    },
    handleSearchOnChange: {
      type: 'function',
      default: function _default(searchText, foundArrayItems) {
        console.log("----- search on change -----");
        console.log(searchText);
        console.log(foundArrayItems);
      }
    },
    handleSelectedItem: {
      type: 'function',
      default: function _default(selectedItem, selectedItemText, selectedItemIndex, isItemAlreadySelected) {
        console.log("----- item selected details -----");
        console.log(selectedItem);
        console.log(selectedItemText);
        console.log(selectedItemIndex);
        console.log(isItemAlreadySelected);
      }
    }
  }
};
exports.default = _default2;